import React from 'react';
import PropTypes from 'prop-types';

import './Legend.scss';

const Legend = ({ legend, index }) => (
  <div className="legend">
    <div className={`legend__box ${index % 2 === 0 ? 'legend__box--green' : 'legend__box--teal' }`}  />
    <span className="legend__text">{legend}</span>
  </div>
)

Legend.propTypes = {
  index: PropTypes.number,
  legend: PropTypes.string
}

Legend.defaultProps = {
  index: 0,
  legend: ''
}

export default Legend;
